<template>
    <transition
        :name="!disableFade ? 'quickfade' : ''"
        mode="out-in">
        <div class="loader">
            <div
                :class="`spinner-border text-${variant}`"
                role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <h2
                v-if="status"
                class="loading-status text-primary">
                {{ status }} ...
            </h2>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        status: {
            type: String,
            default: null
        },
        variant: {
            type: String,
            default: 'primary'
        },
        disableFade: {
            type: Boolean,
            default: false
        }
    },
    methods: {}
};
</script>
<style lang="scss">
.loader {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 5rem;

    &.loader-overlay {
        position: absolute;
        z-index: 100;
        top: 0;
        left: 0;

        display: flex;
        flex-direction: column;

        height: 100% !important;

        background-color: rgba(255, 255, 255, 0.9);

        &.parent-has-border {
            outline: 1px solid #fff;
        }
    }
    &.page-overlay {
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;

        display: flex;
        flex-direction: column;

        height: 100%;

        pointer-events: auto;

        background-color: rgba(255, 255, 255, 0.9);
    }
    &.semi-transparent {
        background-color: rgba(255, 255, 255, 0.5) !important;
    }


    .loading-status {
        display: block;

        margin-top: 1.5rem;
        padding: 0 1rem;
    }
}
</style>
